import { useEffect, useRef, createRef, useState, useCallback } from 'react';
import * as L from 'leaflet';
import useFadeMapLayer from '/src/hooks/useFadeMapLayer';
import ModalError from '../Modal/ModalError';

export default function MapTileLayerUrl({map, mapUrl, attribution, show, zIndex}){

    // const map = useRef(null);
    const mapLayer = useRef(null);

    // init map
    useEffect(()=>{
        if(map && mapUrl){
            // Simple tile layer url like used in the leaflet examples
            const newLayer = L.tileLayer(mapUrl, {
                attribution: attribution || false, 
                opacity: show? 1 : 0,
                zIndex: zIndex,
            });
            newLayer.addTo(map);

            mapLayer.current = newLayer;
        }
        return ()=>{
            // Clean up tile layer
            if(map && mapLayer.current){ 
                map.removeLayer(mapLayer.current);
            }
        }
    },[map, mapUrl]);

    useEffect(()=>{
        if(mapLayer.current && !isNaN(parseInt(zIndex))){
            mapLayer.current.setZIndex(zIndex);
        }
    }, [mapLayer, zIndex]);

    useFadeMapLayer(mapLayer, show);

    return (
        null
    )
}